import WelcomeOrConfirmationReminderModal from '.';

export const loadWelcomeOrConfirmationReminderModal = ({ emailAddress, source, shouldReload = false, jrConfigGlobal = window.jrConfigGlobal }: IWelcomeOrConfirmationReminderComponentLoader) => {
  let modalClass;

  switch (source) {
    case 'google_one_tap':
      modalClass = 'google-one-tap-confirm-subscription-modal';
      break;
    case 'confirmation_reminder':
      modalClass = 'confirm-reminder-modal';
      break;
    case 'welcome':
      modalClass = 'welcome-modal';
      break;

    default:
      modalClass = 'welcome-modal';
      break;
  }

  new WelcomeOrConfirmationReminderModal(
    modalClass,
    'jr-modal-wrapper',
    jrConfigGlobal,
    emailAddress,
    source,
    shouldReload,
  ).init();
}
